
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19","height":"19"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"9.5","cy":"9.5","r":"9.5","fill":"#23a455"}}),_c('path',{attrs:{"fill":"#fff","d":"M14.763 6.882l-6.751 6.747-3.778-3.751 1.538-1.511 2.24 2.213 5.209-5.209z"}})])
          )
        }
      }
    